(function () {
  function parseSizeToGrams(text) {
    var normalized = String(text || "").toLowerCase();
    if (normalized.indexOf("100g") !== -1) return 100;
    if (normalized.indexOf("250g") !== -1) return 250;
    if (normalized.indexOf("500g") !== -1) return 500;
    if (normalized.indexOf("1kg") !== -1 || normalized.indexOf("1000g") !== -1) return 1000;
    return 0;
  }

  function formatGrams(value) {
    if (!value) return "0";
    var fixed = value.toFixed(2);
    return fixed.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function PickMixBuilder(root) {
    this.root = root;
    this.form = root.closest("form");
    this.rowsTarget = root.querySelector("[data-pickmix-rows]");
    this.addButton = root.querySelector("[data-pickmix-add]");
    this.helper = root.querySelector("[data-pickmix-helper]");
    this.error = root.querySelector("[data-pickmix-error]");
    this.propertiesTarget = root.querySelector("[data-pickmix-properties]");
    this.variantScript = root.querySelector("[data-pickmix-variants]");
    this.pickmixTag = root.dataset.pickmixTag || "pickmix-option";
    this.limitSmall = Number(root.dataset.sizeLimitSmall || 5);
    this.limitLarge = Number(root.dataset.sizeLimitLarge || 10);
    this.rows = [{ id: Date.now(), value: "" }];
    this.variantCache = [];
    this.sweetOptions = [];

    if (!this.form || !this.rowsTarget) return;
    this.init();
  }

  PickMixBuilder.prototype.init = function () {
    try {
      this.variantCache = JSON.parse(this.variantScript.textContent || "[]");
    } catch (e) {
      this.variantCache = [];
    }

    this.addButton.addEventListener("click", this.handleAddRow.bind(this));
    this.rowsTarget.addEventListener("change", this.handleSelectChange.bind(this));
    this.rowsTarget.addEventListener("click", this.handleRemoveRow.bind(this));
    this.form.addEventListener("submit", this.handleSubmit.bind(this));

    var variantField = this.form.querySelector('input[name="id"], select[name="id"]');
    if (variantField) {
      variantField.addEventListener("change", this.handleVariantChange.bind(this));
    }

    this.fetchSweetOptions();
  };

  PickMixBuilder.prototype.fetchSweetOptions = function () {
    var endpoint = "/products.json?limit=250";
    fetch(endpoint, { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(
        function (payload) {
          var products = (payload && payload.products) || [];
          var tag = this.pickmixTag.toLowerCase();
          this.sweetOptions = products
            .filter(function (p) {
              if (!p || !p.tags) return false;
              return String(p.tags)
                .toLowerCase()
                .split(",")
                .map(function (value) {
                  return value.trim();
                })
                .indexOf(tag) !== -1;
            })
            .map(function (p) {
              return p.title;
            })
            .sort(function (a, b) {
              return a.localeCompare(b);
            });

          if (!this.sweetOptions.length) {
            this.setError("No sweets found. Add the tag '" + this.pickmixTag + "' to sweet products.");
          }

          this.render();
          this.updateComputedState();
        }.bind(this)
      )
      .catch(
        function () {
          this.setError("Unable to load sweets right now. Please refresh and try again.");
          this.render();
          this.updateComputedState();
        }.bind(this)
      );
  };

  PickMixBuilder.prototype.getCurrentVariantTitle = function () {
    var field = this.form.querySelector('input[name="id"], select[name="id"]');
    if (!field) return "";

    var id = Number(field.value);
    if (!id) return "";

    var selected = this.variantCache.find(function (variant) {
      return Number(variant.id) === id;
    });
    return selected ? selected.title : "";
  };

  PickMixBuilder.prototype.getSizeLimit = function () {
    var title = this.getCurrentVariantTitle().toLowerCase();
    if (title.indexOf("100g") !== -1 || title.indexOf("250g") !== -1) {
      return this.limitSmall;
    }
    return this.limitLarge;
  };

  PickMixBuilder.prototype.getSelectedValues = function () {
    return this.rows
      .map(function (row) {
        return row.value;
      })
      .filter(Boolean);
  };

  PickMixBuilder.prototype.handleVariantChange = function () {
    var limit = this.getSizeLimit();
    if (this.rows.length > limit) {
      this.rows = this.rows.slice(0, limit);
    }
    this.render();
    this.updateComputedState();
  };

  PickMixBuilder.prototype.handleAddRow = function () {
    this.clearError();
    var limit = this.getSizeLimit();
    if (this.rows.length >= limit) {
      this.setError("You can choose up to " + limit + " sweets for this size.");
      return;
    }

    this.rows.push({
      id: Date.now() + Math.floor(Math.random() * 1000),
      value: "",
    });
    this.render();
    this.updateComputedState();
  };

  PickMixBuilder.prototype.handleRemoveRow = function (event) {
    var trigger = event.target.closest("[data-pickmix-remove]");
    if (!trigger) return;

    this.clearError();
    var rowId = Number(trigger.getAttribute("data-pickmix-remove"));
    this.rows = this.rows.filter(function (row) {
      return row.id !== rowId;
    });

    if (!this.rows.length) {
      this.rows = [{ id: Date.now(), value: "" }];
    }

    this.render();
    this.updateComputedState();
  };

  PickMixBuilder.prototype.handleSelectChange = function (event) {
    var select = event.target.closest("[data-pickmix-select]");
    if (!select) return;

    this.clearError();
    var rowId = Number(select.getAttribute("data-pickmix-select"));
    var value = select.value;

    this.rows = this.rows.map(function (row) {
      if (row.id === rowId) row.value = value;
      return row;
    });
    this.updateComputedState();
  };

  PickMixBuilder.prototype.handleSubmit = function (event) {
    this.clearError();

    var selected = this.getSelectedValues();
    var limit = this.getSizeLimit();
    var hasUnselectedRows = this.rows.some(function (row) {
      return !row.value;
    });

    if (selected.length < 1) {
      event.preventDefault();
      this.setError("Choose at least one sweet before adding to cart.");
      return;
    }

    if (selected.length > limit) {
      event.preventDefault();
      this.setError("You can choose up to " + limit + " sweets for this size.");
      return;
    }

    if (hasUnselectedRows) {
      event.preventDefault();
      this.setError("Fill or remove empty sweet rows before adding to cart.");
      return;
    }

    this.writeLineItemProperties(selected);
  };

  PickMixBuilder.prototype.writeLineItemProperties = function (selected) {
    this.propertiesTarget.innerHTML = "";
    var grams = parseSizeToGrams(this.getCurrentVariantTitle());
    var each = selected.length ? grams / selected.length : 0;

    selected.forEach(
      function (name, index) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[Sweet " + (index + 1) + "]";
        input.value = name;
        this.propertiesTarget.appendChild(input);
      }.bind(this)
    );

    var countInput = document.createElement("input");
    countInput.type = "hidden";
    countInput.name = "properties[Mix Count]";
    countInput.value = String(selected.length);
    this.propertiesTarget.appendChild(countInput);

    var gramsInput = document.createElement("input");
    gramsInput.type = "hidden";
    gramsInput.name = "properties[Each Sweet]";
    gramsInput.value = formatGrams(each) + "g";
    this.propertiesTarget.appendChild(gramsInput);
  };

  PickMixBuilder.prototype.updateComputedState = function () {
    var selected = this.getSelectedValues();
    var grams = parseSizeToGrams(this.getCurrentVariantTitle());
    var each = selected.length ? grams / selected.length : 0;
    var limit = this.getSizeLimit();

    if (selected.length > 0 && grams > 0) {
      this.helper.textContent =
        "Selected: " +
        selected.length +
        " sweet" +
        (selected.length === 1 ? "" : "s") +
        " | Each sweet gets " +
        formatGrams(each) +
        "g.";
    } else {
      this.helper.textContent = "Choose up to " + limit + " sweets for this size.";
    }

    this.addButton.disabled = this.rows.length >= limit;
  };

  PickMixBuilder.prototype.setError = function (message) {
    this.error.hidden = false;
    this.error.textContent = message;
  };

  PickMixBuilder.prototype.clearError = function () {
    this.error.hidden = true;
    this.error.textContent = "";
  };

  PickMixBuilder.prototype.render = function () {
    var optionsHtml = this.sweetOptions
      .map(function (title) {
        var safeTitle = escapeHtml(title);
        return '<option value="' + safeTitle + '">' + safeTitle + "</option>";
      })
      .join("");

    var rowsHtml = this.rows
      .map(
        function (row, index) {
          var placeholder = index === 0 ? "Pick your first sweet" : "Pick another sweet";
          return (
            '<div class="pickmix-builder__row">' +
            '<select class="pickmix-builder__select" data-pickmix-select="' +
            row.id +
            '" aria-label="' +
            placeholder +
            '">' +
            '<option value="">' +
            placeholder +
            "</option>" +
            optionsHtml +
            "</select>" +
            '<button type="button" class="pickmix-builder__remove" data-pickmix-remove="' +
            row.id +
            '"' +
            (this.rows.length === 1 ? " hidden" : "") +
            ">Remove</button>" +
            "</div>"
          );
        }.bind(this)
      )
      .join("");

    this.rowsTarget.innerHTML = rowsHtml;

    this.rows.forEach(
      function (row) {
        var select = this.rowsTarget.querySelector('[data-pickmix-select="' + row.id + '"]');
        if (select) select.value = row.value;
      }.bind(this)
    );
  };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-pickmix-builder]").forEach(function (builderEl) {
      new PickMixBuilder(builderEl);
    });
  });
})();
